import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // empty or your global overrides
import './style.css';
import 'swiper/css/bundle';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
